interface ReportStatCardProps {
  icon: string;
  label: string;
  value: string;
  trend: number;
  color: "orange" | "emerald" | "red" | "amber";
  sub: string;
}

const colorMap = {
  orange: { bg: "bg-orange-50", text: "text-orange-600" },
  emerald: { bg: "bg-emerald-50", text: "text-emerald-600" },
  red: { bg: "bg-red-50", text: "text-red-600" },
  amber: { bg: "bg-amber-50", text: "text-amber-600" },
};

export default function ReportStatCard({ icon, label, value, trend, color, sub }: ReportStatCardProps) {
  const c = colorMap[color];
  const isPositive = trend > 0;
  const isNeutral = trend === 0;

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-5">
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${c.bg} ${c.text}`}>
          <i className={`${icon} text-lg`}></i>
        </div>
        {!isNeutral && (
          <span
            className={`flex items-center gap-0.5 text-xs font-semibold px-2 py-0.5 rounded-full ${
              isPositive
                ? "bg-emerald-50 text-emerald-600"
                : "bg-red-50 text-red-500"
            }`}
          >
            <i className={`${isPositive ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-sm`}></i>
            {Math.abs(trend)}{typeof trend === "number" && String(trend).includes(".") ? "" : ""}
          </span>
        )}
      </div>
      <p className="text-2xl font-bold text-gray-900">{value}</p>
      <p className="text-sm font-medium text-gray-700 mt-0.5">{label}</p>
      <p className="text-xs text-gray-400 mt-0.5">{sub}</p>
    </div>
  );
}
